import type { TTourAnchorRect } from '../types';

type TAnchorHandle = {
  measure: () => Promise<TTourAnchorRect | null>;
};

const anchors = new Map<string, TAnchorHandle>();

export const registerTourAnchor = (name: string, handle: TAnchorHandle): (() => void) => {
  anchors.set(name, handle);

  return () => {
    if (anchors.get(name) === handle) {
      anchors.delete(name);
    }
  };
};

export const isTourAnchorMounted = (name: string): boolean => anchors.has(name);

export const measureTourAnchor = async (name: string): Promise<TTourAnchorRect | null> => {
  const handle = anchors.get(name);

  if (!handle) {
    return null;
  }

  const rect = await handle.measure();

  if (!rect || rect.width <= 0 || rect.height <= 0) {
    return null;
  }

  return rect;
};
